export const SELECTED_ORG_KEY = 'selected_organisation_id';
